import { registerLocaleData } from '@angular/common';
import localeEs from '@angular/common/locales/es';
import { AppComponent } from './app/app.component';
import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { initializeKeycloak } from './app/keycloak-init';
import { syncAsignacionesActorSession } from './app/modules/asignaciones/utils/asignaciones-actor.util';

registerLocaleData(localeEs);

const publicPaths = ['/catalogo', '/aviso-de-privacidad', '/eliminar-cuenta'];
const isPublicRoute = publicPaths.some(path => window.location.pathname.startsWith(path));

if (isPublicRoute) {
    bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err));
} else {
    initializeKeycloak()
        .then(() => {
            syncAsignacionesActorSession();
            bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err));
        })
        .catch((err) => console.error('Keycloak init failed', err));
}
